import { Smartphone } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { PageShell } from '@/components/layout/PageShell'
import { CommsPage } from '@/features/comms/CommsPage'
import { ExtensionGate } from '@/features/extensions/ExtensionGate'
import { MOBILE_FORENSICS_EXTENSION_ID } from '@/hooks/use-extensions'
import { useCaseContext } from '@/pages/cases/CaseContext'

export default function CaseCommsPage() {
  const { t } = useTranslation()
  const { caseId } = useCaseContext()

  return (
    <PageShell
      layout="full"
      icon={Smartphone}
      title={t('comms.title')}
      summary={t('comms.subtitle')}
    >
      <ExtensionGate
        extensionId={MOBILE_FORENSICS_EXTENSION_ID}
        titleKey="comms.disabled.title"
        bodyKey="comms.disabled.body"
      >
        <CommsPage caseId={caseId} />
      </ExtensionGate>
    </PageShell>
  )
}
